import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'mindbase-counselling-common',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './counselling-common.component.html',
  styleUrl: './counselling-common.component.scss'
})
export class CounsellingCommonComponent {

}
